import React from 'react';

function EtatsFinanciersPage() {
  return (
    <div style={{ padding: 24 }}>
      <h1>États financiers</h1>
      <p>Page `fhc-etats-financiers.html` convertie en composant React.</p>
    </div>
  );
}

export default EtatsFinanciersPage;
